export const SETUP_PATH = '/setup';

export const setupHrefOf = (step: number): string => `${SETUP_PATH}?step=${String(step)}`;
